module.exports = __webpack_public_path__ + "img/ico-caret-blue.ef0b84ff.svg";